import {useEffect} from 'react';

export const setScrollToZero = () => {(document.scrollingElement ? document.scrollingElement : document.documentElement).scrollTop = 0;}

export const useSetScrollToZero = (valid) => useEffect(() => {setScrollToZero()}, [valid])
